import { render, staticRenderFns } from "./LocationHistoryPage.vue?vue&type=template&id=68c80394&"
import script from "./LocationHistoryPage.vue?vue&type=script&lang=ts&"
export * from "./LocationHistoryPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports